<template>
    <div class="row">
        <CreateEditNotification
            :title="titleFormNotification"
            :form="form"
            :errors="errorNotifications"
            :btnLabel="nameBtnFormNotification"
            :loading="loading_submit"
            @submit="submit"
            @cancel="cancelFormNotification"
        />

        <ListNotification
            :notifications="notifications"
            :pagination="paginationNotifications"
            @edit-notification="editNotification"
            @delete-notification="deleteNotification"
            @page-change="handleNotificationsPageChange"
            @disable-notification="disableNotification"
        />

        <ListClients
            :systems="systems"
            :pagination="paginationSystems"
            :status_filter="status_filter"
            :listOptionSearch="listOptionSearch"
            :filter="filter"
            :id_notification_global="id_notification_global"
            :all_notifications="all_notifications"
            :has_selected="has_selected"
            :loadingSubmitMassive="loadingSubmitMassive"
            @change-status-filter="changeStatusFilter"
            @change-filter="changeFilter"
            @change-id-notification-global="changeIdNotificationGlobal"
            @submit-message-massive="submitMessageMassive"
            @submit-message="submitMessage"
            @page-change="handleSystemsPageChange"
        />
    </div>
</template>

<script>
    import CreateEditNotification from './partials/CreateEditNotification.vue'
    import ListNotification from './partials/ListNotification.vue'
    import ListClients from './partials/ListClients.vue'

    export default {
        components: {
            CreateEditNotification,
            ListNotification,
            ListClients
        },
        data() {
            return {
                resource: 'notifications',
                form: {},
                notifications: [],
                all_notifications: [],
                loading_submit: false,
                status_filter: 'all',
                systems: [],
                paginationNotifications: {},
                errorNotifications: {},
                paginationSystems: {},
                filter: {
                    column: 'hostname',
                    value: null
                },
                listOptionSearch: [
                    {
                        id: 'hostname',
                        text: "Hostname"
                    },
                    {
                        id: 'name',
                        text: "Nombre"
                    },
                    {
                        id: 'ruc',
                        text: "RUC"
                    },
                ],
                typingTimer: null,
                id_notification_global: null,
                loadingSubmitMassive: false
            }
        },
        watch: {
            'filter.value': function(newVal, oldVal) {
                if (this.typingTimer) {
                    clearTimeout(this.typingTimer)
                }
                this.typingTimer = setTimeout(async () => {
                    this.paginationSystems.current_page = 1
                    await this.getSystems()
                }, 500)
            }
        },
        computed: {
            titleFormNotification() {
                return this.form.id ? 'Editar Notificación' : 'Crear Notificación'
            },
            nameBtnFormNotification() {
                return this.form.id ? 'Actualizar Notificación' : 'Crear Notificación'
            },
            has_selected() {
                return this.systems.some(system => system.selected)
            }
        },
        async created() {
            this.initForm()
            await this.getAllNotifications()
            await this.getNotifications()
            await this.getSystems()
            this.assignNotificationGlobal()
        },
        methods: {
            initForm() {
                this.form = {
                    id: null,
                    title: null,
                    message: null
                }
                this.errorNotifications = {}
            },

            async getAllNotifications() {
                try {
                    const { data } = await this.$http.get(`/${this.resource}/getAllNotifications`)
                    this.all_notifications = data.data
                } catch (error) {
                    let message = error.response.data.message || 'Error al cargar los registros'
                    this.$message.error(message)
                }
            },

            async getNotifications() {
                try {
                    const { data } = await this.$http.get(`/${this.resource}/getNotifications`, {
                        params: {
                            page: this.paginationNotifications.current_page
                        }
                    })
                    this.notifications = data.data
                    this.paginationNotifications = data.meta
                } catch (error) {
                    let message = error.response.data.message || 'Error al cargar los registros'
                    this.$message.error(message)
                }
            },

            async submit() {
                try {
                    this.loading_submit = true
                    const { data } = await this.$http.post(`/${this.resource}`, this.form)
                    if (data.success) {
                        this.$message.success(data.message)
                        this.initForm()
                        await this.getNotifications()
                        await this.getAllNotifications()
                        this.reassignIdNotification()
                    } else {
                        this.$message.error(data.message)
                    }
                } catch (error) {
                    if (error.response.status === 422) {
                        this.errorNotifications = error.response.data
                    }
                } finally {
                    this.loading_submit = false
                }
            },

            async deleteNotification(id) {
                try {
                    this.$confirm('¿Está seguro de eliminar esta notificación?', 'Advertencia', {
                        confirmButtonText: 'Sí, eliminar',
                        cancelButtonText: 'Cancelar',
                        type: 'warning'
                    }).then(async () => {
                        const { data } = await this.$http.delete(`/${this.resource}/${id}`)
                        if (data.success) {
                            this.$message.success(data.message)
                            await this.getNotifications()
                            await this.getAllNotifications()
                            this.reassignIdNotification()
                        } else {
                            this.$message.error(data.message)
                        }
                    }).catch(() => {
                        // Acción cancelada
                    })
                } catch (error) {
                    console.error(error)
                }
            },

            async getSystems() {
                try {
                    const { data } = await this.$http.get(`/${this.resource}/getSystems`, {
                        params: {
                            page: this.paginationSystems.current_page,
                            status: this.status_filter,
                            search: this.filter
                        }
                    })
                    const notification = this.getIdNotificationByDefault()
                    this.systems = data.data.map(system => {
                        return {
                            ...system,
                            selected: false,
                            notification_id: notification,
                            loading: false
                        }
                    })
                    this.paginationSystems = data.meta
                } catch (error) {
                    
                }
            },

            async submitMessage(system) {
                try {
                    system.loading = true
                    let message = null
                    let title = null
                    const notification = this.all_notifications.find(n => n.id === system.notification_id)
                    if (notification) {
                        message = notification.message
                        title = notification.title
                    }
                    const { data } = await this.$http.post(`/${this.resource}/send-notification`, {
                        system_id: [system.id],
                        notification_id: system.notification_id,
                        message,
                        title
                    })
                    if (data.success) {
                        this.$message.success(data.message)
                    } else {
                        this.$message.error(data.message)
                    }
                } catch (error) {
                    
                } finally {
                    system.loading = false
                }
            },

            editNotification(id) {
                this.initForm()
                const notification = this.notifications.find(notification => notification.id === id)
                if (notification) {
                    this.form = {...notification}
                }
            },

            cancelFormNotification() {
                this.initForm()
            },

            changeClearInput() {
                this.filter.value = null
                this.paginationSystems.current_page = 1
            },

            async changeStatusFilter(newStatus) {
                this.status_filter = newStatus
                this.changeClearInput()
                await this.getSystems()
            },

            assignNotificationGlobal() {
                const notification = this.getIdNotificationByDefault()
                this.id_notification_global = notification
            },

            async submitMessageMassive() {
                try {
                    this.loadingSubmitMassive = true
                    let message = null
                    let title = null
                    const notification = this.all_notifications.find(n => n.id === this.id_notification_global)
                    if (notification) {
                        message = notification.message
                        title = notification.title
                    }
                    const selectedSystems = this.systems
                            .filter(system => system.selected)
                            .map(system => system.id)
                    const { data } = await this.$http.post(`/${this.resource}/send-notification`, {
                        system_id: selectedSystems,
                        notification_id: this.id_notification_global,
                        message,
                        title
                    })
                    if (data.success) {
                        this.$message.success(data.message)
                    } else {
                        this.$message.error(data.message)
                    }
                } catch (error) {
                    
                } finally {
                    this.loadingSubmitMassive = false
                }
            },

            async disableNotification(id, active) {
                try {
                    let message = active ? '¿Está seguro de inhabilitar esta notificación?' : '¿Está seguro de habilitar esta notificación?'
                    this.$confirm(message, 'Advertencia', {
                        confirmButtonText: 'Sí',
                        cancelButtonText: 'Cancelar',
                        type: 'warning'
                    }).then(async () => {
                        const { data } = await this.$http.put(`/${this.resource}/change-active-notification/${id}`, {
                            active
                        })
                        if (data.success) {
                            this.$message.success(data.message)
                            await this.getNotifications()
                            await this.getAllNotifications()
                            this.reassignIdNotification()
                        } else {
                            this.$message.error(data.message)
                        }
                    }).catch(() => {
                        // Acción cancelada
                    })

                    
                } catch (error) {
                    
                }
            },

            getIdNotificationByDefault() {
                return Array.isArray(this.all_notifications) && this.all_notifications.length
                    ? this.all_notifications[0].id
                    : null
            },

            handleNotificationsPageChange(page) {
                this.paginationNotifications.current_page = page
                this.getNotifications()
            },

            handleSystemsPageChange(page) {
                this.paginationSystems.current_page = page
                this.getSystems()
            },

            changeFilter(newFilter) {
                this.filter = {...this.filter, ...newFilter}
            },

            changeIdNotificationGlobal(newId) {
                this.id_notification_global = newId
            },

            reassignIdNotification() {
                const notification_id = this.getIdNotificationByDefault()
                this.id_notification_global = notification_id
                this.systems = this.systems.map(system => {
                    return {
                        ...system,
                        notification_id: notification_id
                    }
                })
            }
        }
    }
</script>

<style>
    .has-danger .help-block,
    .has-danger .control-label,
    .has-danger .radio,
    .has-danger .checkbox,
    .has-danger .radio-inline,
    .has-danger .checkbox-inline,
    .has-danger.radio label,
    .has-danger.checkbox label,
    .has-danger.radio-inline label,
    .has-danger.checkbox-inline label {
        color: #d2322d;
    }

    .form-control-feedback {
        color: #d2322d;
    }
</style>


// WEBPACK FOOTER //
// resources/js/views/system/notifications/index.vue